import {Component, EventEmitter, Injector, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from 'src/app/shared/dialog/dialog.service';
import {DefiniceVykazuDataService} from "../definice-vykazu-data/definice-vykazu-data.service";
import {
  CreateDefiniceVykazu,
  DefinicePolozkyVykazu,
  DefiniceVykazuDto,
  EditDefiniceVykazu,
  Indexes,
  IndexParam,
  OpakovaneRadky,
  TypHodnoty,
  TypVypoctuHlavniKnihy
} from "../definice-vykazu-data/models/DefiniceVykazuDto";
import {Row, Workbook, Worksheet} from "exceljs";
import {DetailService, Field} from "../shared/detail/detail.service";
import {UcetniJednotkaDetailService} from "../ucetni-jednotka/ucetni-jednotka-detail.service";
import {MasterDetailHub} from "../shared/master-detail/master-detail-hub.service";
import {ApiAttributeParams, MapperDefaultValues, MapperKeys} from "../shared/crud/abstractions/base-crud";
import {UcetniJednotkaDto} from "../ucetni-jednotka-data/models/UcetniJednotkaDtos";
import {UcetniJednotkaDataService} from "../ucetni-jednotka-data/ucetni-jednotka-data.service";
import {of} from "rxjs";
import {TableDialogComponent} from "../shared/cml-forms/show-table.dialog/table-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {DefiniceVykazuFormatDataService} from "../definice-vykazu-format-data/definice-format-vykazu-data.service";
import {DefiniceVykazuFormDialogService} from "./definice-vykazu-form-dialog-service";
import {FormGroup} from "@angular/forms";

const typyVypoctuHlavniKnihy = [
  { value: TypVypoctuHlavniKnihy.Su, displayValue: 'SU' },
  { value: TypVypoctuHlavniKnihy.SuHc, displayValue: 'SU, Hlavní činnost' },
  { value: TypVypoctuHlavniKnihy.SuAu, displayValue: 'SU, AU' },
  { value: TypVypoctuHlavniKnihy.SuAuHc, displayValue: 'SU, AU, Hlavní činnost' }
]

const vypocetHKOptions = {
  observable: of(typyVypoctuHlavniKnihy),
  optionName: 'displayValue',
  optionValue: 'value',
};

const definiceVykazuOptions = {
  observable: of
    ([
      { value: 'ROZ', displayValue: 'A1: Rozvaha' },
      { value: 'VZZ', displayValue: 'A2: Výkaz zisku a ztráty - VZZ' },
      { value: 'PPT', displayValue: 'A3: Přehled o peně. tocích - PPT' },
      { value: 'ZVK', displayValue: 'A4: Přehled o změn. vl. kapitálu - ZVK' },
      { value: 'PRI', displayValue: 'A5: Příloha - PRI' }
    ]),
  optionName: 'displayValue',
  optionValue: 'value',
};

const COLUMNS: Field[] = [
  { name: "kod", type: "dropdown", title: "Definice výkazu", required: true, observable: definiceVykazuOptions },
  { name: "popis", type: "string", title: "Popis", maxLength: 255 },
  { name: "nazev", type: "string", title: "Název", maxLength: 255, required: true, },
  { name: "refVysledky", type: "boolean", title: "Používá ref. výsledky", required: true, default: true },
  { name: "typVypoctuHlavniKnihy", type: "dropdown", title: "Rozpad hlavní knihy", required: true, observable: vypocetHKOptions },

];

const COPY_COLUMNS: Field[] =
  [
    { name: "kodUj", type: "autocomplete", title: "Účetní jednotka", required: true },
  ];

const EDIT_COLUMNS: Field[] =
  [
    { name: "kod", type: "dropdown", title: "Definice výkazu", readonly: true, observable: definiceVykazuOptions },
    { name: "platnaOd", type: "date", title: "Od", maxLength: 255 },
    { name: "platnaDo", type: "date", title: "Do", maxLength: 255 },
    { name: "popis", type: "string", title: "Popis", maxLength: 255 },
    { name: "nazev", type: "string", title: "Název", maxLength: 255, required: true, },
    { name: "pouzivaReferencniVysledekVypoctu", type: "boolean", title: "Používá ref. výsledky", required: true },
    { name: "typVypoctuHlavniKnihy", type: "dropdown", title: "Rozpad hlavní knihy", required: true, observable: vypocetHKOptions },
  ];


@Component({
    selector: 'cml-definice-vykazu',
    templateUrl: 'definice-vykazu.component.html',
    styleUrls: ['../ucetni-jednotka/ucetni-jednotka-detail.component/ucetni-jednotka-detail.component.scss'],
    standalone: false
})

export class DefiniceVykazuComponent implements OnInit
{
  @Output() definiceJednotky: EventEmitter<DefiniceVykazuDto[]> = new EventEmitter<DefiniceVykazuDto[]>();

  public entity: any;
  postJsonData: CreateDefiniceVykazu = {};
  userFormData: any;
  entityId: string;
  dataSource: Array<DefiniceVykazuDto> = [];
  columns= COLUMNS;
  copyColumns = COPY_COLUMNS;
  editColumns = EDIT_COLUMNS;
  tableColumns: Field[]=
    [
      {name:'kod',title: 'Kód',type:""},
      {name:'nazev',title: 'Název',type:""},
      {name:'platnaOd',title: 'Od',type:"date"},
      {name:'platnaDo',title: 'Do',type:"date"},
      {name:'pouzivaReferencniVysledekVypoctu',title: 'Ref. výsledky',type:"boolean"},
      {name:'popis',title: 'Popis',type:""},
      {name:'kodUj',title: 'Kód uj',type:""},
      {name:'id',title: 'Id definice',type:""},
      {name:'typVypoctuHlavniKnihyDisplayValue',title: 'Rozpad HK', type:""}
    ];
  displayedColumns: string[] = ['kod','nazev','platnaOd','platnaDo','pouzivaReferencniVysledekVypoctu','id','popis','typVypoctuHlavniKnihyDisplayValue','editAction','deleteAction']
  explansionPanelState = false;

  excelFile? : string | ArrayBuffer;
  fileParsedErrorMessage = '';

  protected detailService: DetailService | any;

  constructor(private dataService: DefiniceVykazuDataService, private route: ActivatedRoute,
              public router: Router, private dialogService: DialogService, protected injector: Injector,protected masterDetailHub: MasterDetailHub,
              private ujDataService: UcetniJednotkaDataService, private matDialog: MatDialog, private vykazyDataService: DefiniceVykazuFormatDataService)
  {
    route.params.subscribe( params =>
    {
      if (this.dataService) {
        this.entityId = params['id'];
        this.getAllDataFromApi();
      }
    });
    this.entityId = this.route.snapshot.params['id'];
    if (route.routeConfig && route.routeConfig.data) {
      this.detailService = this.injector.get(route.routeConfig.data['detailService']);
    }
    }
  async ngOnInit()
  {
    await this.getAllDataFromApi();
  }

  private async addObservable(columns: Field[]) {
    const mapped = this.dataService.setMapper({key: MapperKeys.MaxResultCount, value: MapperDefaultValues.MaxResultCount})
    let ucetniJednotky: UcetniJednotkaDto[] = await this.ujDataService.getAll({params: mapped});

    //odstranění UJ, na kterou kopíruju, nechceme kopírovat samotnou do sebe
    ucetniJednotky = ucetniJednotky.filter(x => x.kod != this.entityId);

    ucetniJednotky.forEach( x=> x.displayValue = `${x.kod} - ${x.nazev}`)
    let observableUJ = {
      observable: of(ucetniJednotky),
      optionName: 'displayValue',
      optionValue: 'kod'
    }
    let field = columns.find( x=> x.name === 'kodUj')
    if(field) {
      field.observable = observableUJ;
    }
  }

  private async parseVykazyOfDefinice(chosenDefinice: DefiniceVykazuDto[], resUj: string)
  {
    for(const element of chosenDefinice)
    {
      try
      {
        const stringId = element.id.toString();
        const definice = await this.getAndModifyDefinice(stringId); //musi byt pro ziskani definicPolozek a opakujicich radku

        const vykazy = await this.vykazyDataService.getVykazyById(stringId); //vykazy stare definice, ze ktere kopirujeme
        for (let vykaz of vykazy)
        {
          vykaz.idDefiniceVykazu = definice.id;
          vykaz.kodUj = definice.kodUj;
          vykaz.specifikace += ``
          vykaz.urceniFormatuVykazu = [{kodPravniFormy:resUj, idDefiniceFormatu: definice.id}]
          await this.vykazyDataService.create('',vykaz)
        }
      }
      catch (e)
      {
        await this.dialogService.handleError(e)
      }
    }
    await this.getAllDataFromApi();
  }

  private async getAndModifyDefinice(id: string) {
    let definice = await this.dataService.get(id);
    definice.popis = '';
    definice.kodUj = this.entityId;
    return await this.dataService.create('', definice);
  }

  public async copyDefinice()
  {
    await this.addObservable(this.copyColumns);
    let resUj = await this.dialogService.form({title: "Kopírování definic", detail: this.copyColumns});
    const mapped = this.dataService.setMapper(
      [
        {key: MapperKeys.KodUj, value: resUj.value.kodUj.kod},
        {key: MapperKeys.MaxResultCount, value: MapperDefaultValues.MaxResultCount}
      ])
    const resDefinice = await this.dataService.getAll({params: mapped});
    if(!resDefinice.length)
    {
      return this.dialogService.alert({title: "Chyba", detail: "Vybaraná účetní jednotka neobsahuje žádné definice!"});
    }

    const dialogRef = this.matDialog.open(TableDialogComponent, { data:
        {
          title: `Kopírování definice výkazu a formátů výkazů z ${resUj.value.kodUj.displayValue}`,
          filter: false,
          dataSource: resDefinice,
          columns: this.tableColumns,
          selectable: true,
          displayedColumns: ['select','kod','nazev','id'],
      },
      panelClass: 'dialog-panel' });
    dialogRef.afterClosed().subscribe(result => {
      this.parseVykazyOfDefinice(result,resUj.value.kodUj.kodPravniFormy);
    });

  }

  private async getAllDataFromApi() {
    const mapped = this.dataService.setMapper(
      [
        { key: MapperKeys.KodUj, value: this.entityId },
        { key: MapperKeys.MaxResultCount, value: MapperDefaultValues.MaxResultCount }
      ])
    const result = await this.dataService.getAll({ params: mapped });
    result.forEach(x => x.typVypoctuHlavniKnihyDisplayValue = typyVypoctuHlavniKnihy.find(y => y.value === x.typVypoctuHlavniKnihy)?.displayValue);
    this.dataSource = result;
    this.definiceJednotky.emit(result)
  }

  private async postDataToApi()
  {

     const res = await this.dataService.create("",this.postJsonData);
     if(res != null)
       await this.getAllDataFromApi()
  }

  parseEditedDefinice(userResponse: any,notEditedData: any)
  {
    const parsed : EditDefiniceVykazu = {
      kod: userResponse.controls.kod?.value,
      nazev: userResponse.value.nazev,
      popis: userResponse.value.popis,
      platnaOd: userResponse.value.platnaOd,
      platnaDo: userResponse.value.platnaDo,
      pouzivaReferencniVysledekVypoctu: userResponse.value.pouzivaReferencniVysledekVypoctu,
      kodUj: this.entityId,
      opakovaneRadky: notEditedData.opakovaneRadky,
      urceniDefiniceVykazu: notEditedData.urceniDefiniceVykazu,
      definicePolozkyVykazu: notEditedData.definicePolozkyVykazu,
      typVypoctuHlavniKnihy: userResponse.value.typVypoctuHlavniKnihy
    }
    return parsed;
  }
  async openEditDefinice(rowRaw : any)
  {
    const idDefinice = this.dataSource[rowRaw].id.toString();
    const res : DefiniceVykazuDto = await this.dataService.get(idDefinice);
    const detail = this.addValuesToPrefilledForm(this.editColumns,res)

    const userResponse = await this.dialogService.form({
      title: "Editace definice výkazu",
      detail,
    })

    if(userResponse)
    {
      const parsedEdit = this.parseEditedDefinice(userResponse, res)
      await this.dataService.edit(idDefinice,parsedEdit,ApiAttributeParams.idDefinice);
      await this.getAllDataFromApi();
    }
  }

  navigateToFormat()
  {
    this.router.navigate([this.router.url + '/formaty-definice']);
  }

  addValuesToPrefilledForm(columnsTemplate: Field[], data: any)
  {
    let copyColumns: Field[] = [];
    //Deep copy
    columnsTemplate.forEach(x => {copyColumns.push(Object.assign({},x))});
    copyColumns.forEach(x => x.default =  data[x.name])
    return copyColumns;
  }

  public listenForChange(form: FormGroup)
  {
  }

  public async newDefiniceModal(prefilledData: boolean = false, template: Field[] = this.columns)
  {
    const detail = prefilledData
      ? this.addValuesToPrefilledForm(template,this.userFormData.value)
      : template;

    this.userFormData = await this.dialogService.form({
      title: "Nová definice výkazu",
      detail,
      uploadFile: true,
      validation:true,
      component:this

    }, DefiniceVykazuFormDialogService);

    if (this.userFormData)
    {
      const entity = await (<UcetniJednotkaDetailService>this.detailService).get(this.entityId);
      this.postJsonData.kod = this.userFormData.value.kod;
      this.postJsonData.nazev = this.userFormData.value.nazev;
      this.postJsonData.popis = this.userFormData.value.popis;
      this.postJsonData.platnaOd = new Date().toISOString();
      this.postJsonData.platnaDo = new Date("9999-12-31").toISOString();
      this.postJsonData.pouzivaReferencniVysledekVypoctu = this.userFormData.value.refVysledky;
      this.postJsonData.kodUj = this.entityId;
      this.postJsonData.urceniDefiniceVykazu = [{kodPravniFormy:entity.kodPravniFormy}];
      this.postJsonData.typVypoctuHlavniKnihy = this.userFormData.value.typVypoctuHlavniKnihy;
      await this.postDataToApi();
    }
  }

  async doValidation(form: FormGroup, columns: Field[]): Promise<boolean> {
    if (!this.excelFile || !form.value.kod) {
      this.fileParsedErrorMessage = 'Pro import je nutné vybrat souobr a definici výkazu.';
      return false;
    }
    if (!await this.tryParseFile(this.excelFile, form.value.kod)) {
      this.fileParsedErrorMessage = 'Zpracování souboru selhalo.';
      return false;
    }
    return true;
  }

  private cellValue(data: any, index: number)
  {
    let cell: any = data.getCell(index).value;
    return typeof cell === 'object' ? cell?.result : cell;
  }

  private parseDefinicePolozky(worksheet: Worksheet, kodDefinice: string) {
    let definicePolozkyVykazu: DefinicePolozkyVykazu[] = [];
    let indexes: Indexes = new Indexes();
    let data = worksheet.getRow(2);

    const params: IndexParam[] = Object.values(indexes);
    for (let i = 1; i <= worksheet.actualColumnCount; i++) {
      const param = params.find(x => x.name.trim().toLowerCase() === data.getCell(i)?.toString().trim().toLowerCase());
      if (param) {
        param.index = i;
      }
    }

    for (let i = 3; i < worksheet.getSheetValues().length; i++) {
      let data = worksheet.getRow(i);
      if ((data.getCell(indexes.levelVypoctu.index).value || data.getCell(indexes.levelVypoctu.index).value === 0)) {
        let result: DefinicePolozkyVykazu =
        {
          poradiRadku: this.cellValue(data, indexes.poradiRadku.index) as number,
          poradiSloupce: this.cellValue(data, indexes.poradiSloupce.index) as number,
          kodRadku: this.cellValue(data, indexes.kodRadku.index) as string,
          kodSloupce: this.cellValue(data, indexes.kodSloupce.index) as string,
          vzorec: this.cellValue(data, indexes.vzorec.index) as string ?? '=0',
          levelVypoctu: this.cellValue(data, indexes.levelVypoctu.index) as number,
          popis: this.getPopis(data, indexes, kodDefinice),
          zpusobZiskaniHodnoty: this.cellValue(data, indexes.zpusobZiskaniHodnoty.index) as number,
          typHodnotyVysledku: this.assignTypHodnoty(this.cellValue(data, indexes.typHodnotyVysledku.index)) as number,
          manualniHodnotaSeVyplnuje: (this.cellValue(data, indexes.manualniHodnota.index) as string).trim().toLowerCase() == 'ano',
        };
        definicePolozkyVykazu.push(result)
      }
    }
    this.postJsonData.definicePolozkyVykazu = definicePolozkyVykazu;
  }

  private getPopis(data: Row, indexes: Indexes, kodDefinice: string): string {
    let popisObj: any = {
      nazevSloupce: this.cellValue(data, indexes.popisNazevSloupce.index),
      nazev: this.cellValue(data, indexes.popisNazev.index)
    };
    if (kodDefinice === 'PRI') {
      popisObj.podrozvahovyUcet = this.cellValue(data, indexes.popisPodrozvahovyUcet.index);
    } else if (kodDefinice === 'ROZ' || kodDefinice === 'VZZ') {
      popisObj.syntetickyUcet = this.cellValue(data, indexes.popisSyntetickyUcet.index);
    }
    return JSON.stringify(popisObj);
  }

  private parseOpakovaneRadky(worksheet: Worksheet) {
    let opakovaneRadky: OpakovaneRadky[] = [];
    const index: Indexes = new Indexes();
    if (worksheet?.getRow(1)) {
      let data = worksheet.getRow(1);
      const params: IndexParam[] = Object.values(index);
      for (let i = 1; i <= worksheet.actualColumnCount; i++) {
        const param = params.find(x => x.name.trim().toLowerCase() === data.getCell(i)?.toString().trim().toLowerCase());
        if (param) {
          param.index = i;
        }
      }

      for (let i = 2; i < worksheet.getSheetValues().length; i++) {
        let data = worksheet.getRow(i);
        let result: OpakovaneRadky =
        {
          kodRadku: this.cellValue(data, index.kodRadku.index)
        };
        opakovaneRadky.push(result);
      }
    }
    this.postJsonData.opakovaneRadky = opakovaneRadky;
  }

  public async tryParseFile(file: any, kodVykazu: string): Promise<boolean> {
    try {
      const wb = new Workbook();
      await wb.xlsx.load(file);
      this.parseDefinicePolozky(wb.worksheets[0], kodVykazu);
      this.parseOpakovaneRadky(wb.worksheets[1]);
      return true;
    } catch {
      return false;
    }
  }

  private async displayAlertAndNewDefiniceModal(title: string, detail: string): Promise<void> {
    await this.dialogService.alert({title, detail});
    return await this.newDefiniceModal(true);
  }

  private assignTypHodnoty(data : string) : number
  {
    const filteredData = data.trim().toLowerCase()
    const typHodnotyMap : Record<string, TypHodnoty> = {
      "string" : TypHodnoty.String,
      "curr" : TypHodnoty.Curr,
      "int" : TypHodnoty.Int,
      "bool" : TypHodnoty.Bool,
      "boolean" : TypHodnoty.Bool,
      "date": TypHodnoty.Date
    };

    if (filteredData in typHodnotyMap) {
      return typHodnotyMap[filteredData];
    } else {
      throw new Error('TypHodnoty doesnt exist.')
    }
  }

  async deleteVykaz(element : any)
  {
    const conf = await this.dialogService.confirm({title: "Odstranění definice", detail:`Chcete opravdu odstranit definici výkazu s kódem:
                                                    <strong>${this.dataSource[element].kod}</strong> a názvem:
                                                    <strong>${this.dataSource[element].nazev}</strong> z účetní jednotky
                                                    <strong>${this.dataSource[element].kodUj}</strong>?`})
    if(!conf) return;
    await this.dataService.delete(this.dataSource[element].id.toString(),ApiAttributeParams.idDefinice)
    await this.getAllDataFromApi()
  }

  public getErrorMessage() {
    return this.fileParsedErrorMessage;
  }

}
